import $http from '@/api';
import LRU from 'lru-cache';

const cache = new LRU({ maxAge: 1000 * 10 });

const getCentralNewsroomTaxonomyMappings = async (id) => {
  if (cache.has(id)) {
    return cache.get(id);
  }
  const result = await $http.get(`/api/central-newsroom/taxonomy-mappings/${id}`);
  cache.set(id, result);
  return result;
};

export default {
  getCentralNewsroomTaxonomyMappings,
};
